export const environment = {
  production: false,
  uri: 'https://sandbox.dev.eu.zuora.com/apps/PublicHostedPageLite.do',
  paymentGateways:
  {
    paymentGateway_tmna: 'TMNA Servco Telematics-Chase',
    paymentGateway_tci: 'TCI - Telematics - Test',
    paymentGateway_tdpr: 'TDPR - Telematics - Test',
    paymentGateway_servco: 'TMNA Servco Telematics-Chase'
  },
  paymentPageIds:
  {
    tmna_servco:
    {
      t_cc_paymentPageId: '78adc8f997177abae17181b3a21f064e',
      t_ach_paymentPageId: '78adc9dee777abac017181acdae32592',
      l_cc_paymentPageId: '78adc8f99777abae017181b1944a0582',
      l_ach_paymentPageId: '78adc8f997177abae01781ab0f48030a'
    },
    tdpr:
    {
      t_cc_paymentPageId: '78adcd9eb72e0d76c0172ea861f46fda',
      l_cc_paymentPageId: '78adcd9eb72e0d76c0172edad5b3470af'
    },
    tci:
    {
      t_cc_paymentPageId: '78adc8f997e0ca880172eda2851e7c93',
      l_cc_paymentPageId: '78adcd9eb72e0d76c0172e9239956bd7'
    }
  }
};
